import React, { useState } from 'react';
import '../pages/Pages.css';
import SalaryCalculator from '../SalaryCalculator';
import TreasuryBillCalculator from '../TreasuryBillCalculator';
import CompoundInterestCalculator from '../CompoundInterestCalculator';
import BreakdownTab from '../BreakdownTab';
import SimpleCalculator from '../SimpleCalculator';
import AdSense from '../AdSense';

const HomePage = () => {
  const [activeTab, setActiveTab] = useState('salary');
  const [tabDirection, setTabDirection] = useState('forward');
  const [growthTable, setGrowthTable] = useState([]);

  const tabs = [
    { id: 'salary', label: 'Salary', icon: '💰' },
    { id: 'compound', label: 'Compound', icon: '💎' },
    { id: 'breakdown', label: 'Breakdown', icon: '📊' },
    { id: 'calculator', label: 'Calc', icon: '🧮' },
    { id: 'invest', label: 'T-Bills', icon: '📈' }
  ];

  const handleTabChange = (tabId) => {
    const currentIndex = tabs.findIndex(tab => tab.id === activeTab);
    const newIndex = tabs.findIndex(tab => tab.id === tabId);
    setTabDirection(newIndex > currentIndex ? 'forward' : 'backward');
    setActiveTab(tabId);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">
          <span className="title-icon">💼</span>
          Financial Calculators
        </h1>
        <p className="page-subtitle">Calculate your financial future with precision</p>
      </div>

      <div className="page-content">
        {process.env.REACT_APP_ADSENSE_SLOT_TOP && (
          <AdSense 
            adSlot={process.env.REACT_APP_ADSENSE_SLOT_TOP}
            adFormat="auto"
            fullWidthResponsive={true}
            className="adsense-banner"
          />
        )}
        
        <div className="calculator-wrapper">
          <div className="tabs">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
                {activeTab === tab.id && <span className="tab-indicator"></span>}
              </button>
            ))}
          </div>

          <div className={`tab-content-wrapper ${tabDirection}`}>
            <div key={activeTab} className="tab-content-inner">
              {activeTab === 'salary' && <SalaryCalculator />}
              {activeTab === 'compound' && (
                <CompoundInterestCalculator onTableGenerated={setGrowthTable} />
              )}
              {activeTab === 'breakdown' && <BreakdownTab growthTable={growthTable} />}
              {activeTab === 'calculator' && <SimpleCalculator />}
              {activeTab === 'invest' && <TreasuryBillCalculator />}
            </div>
          </div>
        </div>
        
        {process.env.REACT_APP_ADSENSE_SLOT_BOTTOM && (
          <AdSense 
            adSlot={process.env.REACT_APP_ADSENSE_SLOT_BOTTOM}
            adFormat="auto"
            fullWidthResponsive={true}
            className="adsense-banner"
          />
        )}
      </div>
    </div>
  );
};

export default HomePage;
